import { FamilyRestroom } from "@mui/icons-material";

let _token = null;
export const Token = {
  get: () => localStorage.getItem('authToken'),
  set: (value) => localStorage.setItem('authToken', value),
};






export const url = "https://kompetenzversicherungsmakler.balkgmbh.de";
//export const url = "http://127.0.0.1:1187"
export function post(bodyText, end) {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url + "/api" + end, false);
    xhr.setRequestHeader("Content-Type", "text/plain");
        
    try {
      xhr.send(JSON.stringify(bodyText));
      console.log(xhr.status);
      if (xhr.status == 200) {
        return xhr.responseText;
        } else {
          return null;
        }
        } catch (error) {
          throw error;
        }
  }
  export function get(bodyText, end) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url + end, false);
    xhr.setRequestHeader("Content-Type", "text/plain");
        
    try {
      xhr.send(JSON.stringify(bodyText));
      console.log(xhr.status);
      if (xhr.status == 200) {
        return xhr.responseText;
        } else {
          return null;
        }
        } catch (error) {
          throw error;
        }
  }
export function ismitglied(){
  let body = {};
  body.token = Token.get();
  return post(body, "/mitgliedschgeck") == "true" ? true : false;


}


